export default __webpack_public_path__ + "static/media/logisticGreenLeft.64ab8190.svg";